'use strict';

var React = require('react');

var SvgMobileAcceptMajor = function SvgMobileAcceptMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a.997.997 0 0 1-.707-.293l-6-6a1 1 0 0 1 1.414-1.414l5.236 5.236 11.298-13.18a1 1 0 0 1 1.518 1.3l-12 14a1.001 1.001 0 0 1-.721.35h-.038"
  }));
};

exports.SvgMobileAcceptMajor = SvgMobileAcceptMajor;
